import React from 'react'
import { bool, node } from 'prop-types'
import styled from '@emotion/styled'

const SectionWrapper = styled.div`
	${({ isBorderRound }) => isBorderRound && `border-radius: 7px`};
	${({ hasPadding }) => hasPadding && `padding: 1.5rem`};
	background: ${({ theme }) => theme.colors.white};
	box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.04);
	max-width: 940px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		${({ hasPadding }) => hasPadding && `padding: 2.5rem`};
	}

	${({ theme }) => theme.MQ.L} {
		margin: auto;
	}
`
/**
 * Section Container that wraps context with a white background and dropshadow
 *
 * @param {Node} props.children :: context that will be wrapped by the Section Container
 * @param {Boolean} props.isBorderRound :: declares if the border should be rounded
 */
export function SectionContainer({ children, hasPadding = true, isBorderRound = true }) {
	return (
		<SectionWrapper hasPadding={hasPadding} isBorderRound={isBorderRound}>
			{children}
		</SectionWrapper>
	)
}

SectionContainer.propTypes = {
	children: node.isRequired,
	isBorderRound: bool,
}
